module.exports = __webpack_public_path__ + "img/cc.b257b605.svg";